// project import
import { NavItemType } from 'types/menu';
import type { UiDesign } from 'types/user';
import getNewDesignItems from './newDesign';
import getItems from './other';

// ==============================|| MENU ITEMS ||============================== //

const getMenuItems = (design: UiDesign = 'CLASSIC'): { items: NavItemType[] } => ({
    items: design === 'NEW' ? getNewDesignItems() : [getItems()],
});

export default getMenuItems;
